// src/moment/components/WordOfTheDay/WordOfTheDaySkeleton.tsx

import { FC } from 'react';
import './WordOfTheDaySkeleton.scss';

const WordOfTheDaySkeleton: FC = () => {
  return (
    <div className="word-skeleton__container" data-testid="word-skeleton">
      <div className="word-skeleton__shimmer"></div>
    </div>
  );
};

export default WordOfTheDaySkeleton;
